import { GenericCrudPage } from '@/components/GenericCrudPage';
import { questionsConfig } from '@/pages/configs';

export default function QuestionsPage() {
  return <GenericCrudPage config={questionsConfig} />;
}
